import React from 'react';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import styles from '../../styles.module.scss';
import PlaceholderAvatar from '../PlaceholderAvatar/PlaceholderAvatar';
import balonUrl from '../../assets/Balon.png';
import flechaAbajoUrl from '../../assets/flechaabajo.png';

const getAssetUrl = (asset, primaryKey, secondaryKey) => {
  const primary = primaryKey ? asset?.[primaryKey] : null;
  const secondary = secondaryKey ? asset?.[secondaryKey] : null;
  const candidate = primary || secondary;
  return typeof candidate === 'string' && candidate.trim() ? candidate : null;
};

export default function PitchPlayer({
  name,
  photo,
  left,
  top,
  yellow,
  red,
  redCard2y,
  goal,
  goalCount,
  subOut,
  isHome = true,
}) {
  const asset = useSelector((state) => state.asset);
  const avatarTeamClass = isHome
    ? styles['wca-lineaciones__pitch-avatar--home']
    : styles['wca-lineaciones__pitch-avatar--away'];

  const showYellowTop = Boolean((yellow && !redCard2y) || redCard2y);
  const showRedTopLeft = Boolean(red && !redCard2y && !yellow);
  const showRedBottomLeft = Boolean(red && !redCard2y && yellow);
  const showDiag2yBottom = Boolean(redCard2y);
  const showGoalNumber = Boolean(goal && goalCount != null && Number(goalCount) >= 2);
  const lastName = String(name || '').trim().split(/\s+/).pop();

  const goalIconUrl =
    getAssetUrl(asset, 'eventodeportivo_icono_gol_1', 'eventodeportivo_icono_gol_2') || balonUrl;
  const subOutIconUrl = getAssetUrl(asset, 'eventodeportivo_icono_sale') || flechaAbajoUrl;
  const yellowCardIconUrl = getAssetUrl(asset, 'eventodeportivo_icono_amarilla_1', 'eventodeportivo_icono_amarilla_2');
  const redCardIconUrl = getAssetUrl(asset, 'eventodeportivo_icono_roja_1', 'eventodeportivo_icono_roja_2');
  const yellowRedCardIconUrl = getAssetUrl(
    asset,
    'eventodeportivo_icono_amarillaroja_1',
    'eventodeportivo_icono_amarillaroja_2',
  );

  return (
    <div
      className={styles['wca-lineaciones__pitch-player']}
      style={{ left: `${left}%`, top: `${top}%` }}
    >
      <div className={styles['wca-lineaciones__pitch-player-body']}>
        <div
          className={classNames(
            styles['wca-lineaciones__pitch-player-iconsCol'],
            styles['wca-lineaciones__pitch-player-iconsCol--left'],
          )}
        >
          <div
            className={classNames(
              styles['wca-lineaciones__pitch-player-iconSlot'],
              styles['wca-lineaciones__pitch-player-iconSlot--leftTop'],
            )}
          >
            {showYellowTop ? (
              yellowCardIconUrl ? (
                <img
                  className={styles['wca-lineaciones__wc-card']}
                  src={yellowCardIconUrl}
                  alt=""
                  width={8}
                  height={12}
                />
              ) : (
                <span
                  className={classNames(
                    styles['wca-lineaciones__wc-card'],
                    styles['wca-lineaciones__wc-card--yellow'],
                  )}
                  aria-hidden
                />
              )
            ) : showRedTopLeft ? (
              redCardIconUrl ? (
                <img
                  className={styles['wca-lineaciones__wc-card']}
                  src={redCardIconUrl}
                  alt=""
                  width={8}
                  height={12}
                />
              ) : (
                <span
                  className={classNames(
                    styles['wca-lineaciones__wc-card'],
                    styles['wca-lineaciones__wc-card--red'],
                  )}
                  aria-hidden
                />
              )
            ) : null}
          </div>
          <div
            className={classNames(
              styles['wca-lineaciones__pitch-player-iconSlot'],
              styles['wca-lineaciones__pitch-player-iconSlot--leftBottom'],
            )}
          >
            {showDiag2yBottom ? (
              yellowRedCardIconUrl ? (
                <img
                  className={styles['wca-lineaciones__wc-card']}
                  src={yellowRedCardIconUrl}
                  alt=""
                  width={8}
                  height={12}
                />
              ) : (
                <span
                  className={classNames(
                    styles['wca-lineaciones__wc-card'],
                    styles['wca-lineaciones__wc-card--diag2y'],
                  )}
                  aria-hidden
                />
              )
            ) : showRedBottomLeft ? (
              redCardIconUrl ? (
                <img
                  className={styles['wca-lineaciones__wc-card']}
                  src={redCardIconUrl}
                  alt=""
                  width={8}
                  height={12}
                />
              ) : (
                <span
                  className={classNames(
                    styles['wca-lineaciones__wc-card'],
                    styles['wca-lineaciones__wc-card--red'],
                  )}
                  aria-hidden
                />
              )
            ) : null}
          </div>
        </div>

        <div className={styles['wca-lineaciones__pitch-player-center']}>
          <PlaceholderAvatar
            photo={photo}
            className={classNames(styles['wca-lineaciones__pitch-avatar'], avatarTeamClass)}
          />
        </div>

        <div
          className={classNames(
            styles['wca-lineaciones__pitch-player-iconsCol'],
            styles['wca-lineaciones__pitch-player-iconsCol--right'],
          )}
        >
          <div
            className={classNames(
              styles['wca-lineaciones__pitch-player-iconSlot'],
              styles['wca-lineaciones__pitch-player-iconSlot--rightTop'],
            )}
          >
            {subOut ? (
              <img
                className={styles['wca-lineaciones__pitch-player-iconImg']}
                src={subOutIconUrl}
                alt=""
                width={12}
                height={12}
              />
            ) : null}
          </div>
          <div
            className={classNames(
              styles['wca-lineaciones__pitch-player-iconSlot'],
              styles['wca-lineaciones__pitch-player-iconSlot--rightBottom'],
            )}
          >
            {goal ? (
              <>
                <img
                  className={styles['wca-lineaciones__pitch-player-iconImg']}
                  src={goalIconUrl}
                  alt=""
                  width={12}
                  height={12}
                />
                {showGoalNumber ? (
                  <span className={styles['wca-lineaciones__pitch-player-goalN']}>{goalCount}</span>
                ) : null}
              </>
            ) : null}
          </div>
        </div>
      </div>

      <span className={styles['wca-lineaciones__pitch-name']}>{lastName}</span>
    </div>
  );
}
